<template>
  <div class="nav-warpper">

    <el-menu
        v-if="noperfect"
        :default-active="navPath"
        :unique-opened="true"
        router
        class="el-menu-vertical-demo"
        text-color="#333"
        active-text-color="#009787"
    >
      <div >
        <el-menu-item :index="path">
          <i class="iconfont iconjigou1" ></i>
          <span slot="title">信息完善</span>
        </el-menu-item>
      </div>
    </el-menu>


    <el-menu
        v-else
        :default-active="navPath"
        :unique-opened="true"
        router
        class="el-menu-vertical-demo"
        text-color="#333"
        active-text-color="#009787"
    >
      <div v-for="(item,index) in nav" :key="index">
        <el-menu-item :index="item.path" v-if="!item.leaf">
          <i class="iconfont" :class="item.icon"></i>
          <!--<span slot="title">{{ item.name }}</span>-->
            <el-badge :value="item.count" :max="99" :hidden="item.count <= 0 " slot="title">
                {{ item.name }}
            </el-badge>
        </el-menu-item>
        <el-submenu :index="index+''" v-if="item.leaf ">
          <template slot="title">
            <i class="iconfont " :class="item.icon"></i>
<!--            <span>{{item.name}}</span>-->
            <el-badge :value="item.count" :max="99" :hidden="item.count <= 0 " slot="title">
              {{ item.name }}
            </el-badge>
          </template>
          <div v-for="child in item.children"  :key="child.path">
            <el-menu-item :index="child.path" >
              <el-badge :value="child.count" :max="99" :hidden="item.count <= 0 " slot="title">
                {{ child.name }}
              </el-badge>
            </el-menu-item>
          </div>
        </el-submenu>
      </div>
    </el-menu>

  </div>
</template>

<script>
// import {adminRouterConfig} from '@/config/router'
import {getMenus} from '@/api/common'
export default {
  name: "adminNav",
  props:{
    navPath:{
      type:String
    }
  },
  data(){
    return {
      nav:[],
      noperfect:false
    }
  },
  computed:{
    u_token(){
      return this.$store.state.token2
    }
  },
  created() {
    if(this.$route.query.noperfect){
      this.noperfect = true
      this.path = this.$route.path
    }else{
      this.getNav()
    }


  },
  methods: {
    async getNav(){
      let _data = await getMenus(this.u_token)
      this.nav = _data.data
    }
  },
  watch:{
    $route() {
      if(!this.$route.query.noperfect){
        this.getNav()
      }

    }
  }
}
</script>

<style scoped lang="scss">
.nav-warpper {
  position: absolute;
  top: 50px;
  left: 0;
  bottom: 0;
  width: 240px;
  background: #e5e5e5;
  overflow-y: scroll;
  p{
    line-height: 40px;
  }
  //.nav-box {
  //  width: 260px;
  //  height: 10000px;background: #000;
  //}
}
</style>